export const USER_ACTIONS = {
	SET: 'USER_SET_DATA',
	SET_LIST: 'USER_SET_LIST',
	UNSET_LIST: 'USER_UNSET_LIST',
	ADD_ADMIN: 'USER_ADD_ADMIN',
	REMOVE_ADMIN: 'USER_REMOVE_ADMIN',
	UPDATE_PROFILE: 'USER_UPDATE_PROFILE'
};

export const LOADER_ACTIONS = {
	ADD: 'LOADER_ADD',
	REMOVE: 'LOADER_REMOVE',
	CLEAR_ALL: 'RESET_LOADER'
};

export const ERROR_ACTIONS = {
	ADD: 'ERROR_ADD',
	DISMISS: 'ERROR_DISMISS',
	CLEAR_ALL: 'ERROR_CLEAR_ALL'
};

export const HOUSE_ACTIONS = {
	LOAD_ALL: 'HOUSE_LOAD_ALL',
	LOAD_ONE: 'HOUSE_LOAD_ONE',
	REMOVE_ONE: 'HOUSE_REMOVE_ONE',
	UPDATE_ONE: 'HOUSE_UPDATE_ONE',
	ASSIGN_MODULES: 'HOUSE_ASSIGN_MODULES',
	REVOKE_MODULES: 'HOUSE_REVOKE_MODULES',
	SET_KFZ: 'HOUSE_SET_KFZ,',
	REMOVE_LOGO: 'HOUSE_REMOVE_LOGO',
	GET_ACTIVE_WORKERS: 'HOUSE_GET_ACTIVE_WORKERS'
};

export const PROCESSING_ACTIONS = {
	ADD: 'PROCESSING_ADD',
	REMOVE: 'PROCESSING_REMOVE',
	CLEAR: 'PROCESSING_CLEAR'
};

export const TIMEZONE_ACTIONS = {
	LOAD: 'TIMEZONE_LOAD'
};

export const SNACKBAR_ACTIONS = {
	SET: 'SNACKBAR_SET',
	UNSET: 'SNACKBAR_UNSET'
};

export const SERVICE_ACTIONS = {
	SET_LIST: 'SERVICE_SET_LIST',
	SET_LIST_RELATIONS: 'SERVICE_SET_LIST_RELATIONS',
	UPDATE_LIST: 'SERVICE_UPDATE_LIST',
	SET_RELATIONS: 'SERVICE_SET_RELATIONS',
	SET_SERVICE: 'SERVICE_SET_ONE',
	ADD_RELATION: 'SERICE_ADD_RELATION',
	TOGGLE: 'SERVICE_TOGGLE_VISIBILITY',
	EXPAND: 'SERVICE_EXPAND_TREE',
	SET_LOGO: 'SERVICE_SET_LOGO'
};

export const PARTS_ACTIONS = {
	EXPAND: 'EXPAND_PART',
	SET_LIST_RELATIONS: 'PARTS_SET_LIST_RELATIONS',
	SET_LIST: 'PARTS_SET_LIST',
	SET_ONE: 'PARTS_SET_ONE',
	REMOVE_ONE: 'PARTS_REMOVE_ONE',
	SET_RELATION: 'PARTS_SET_RELATION'
};

export const MODULE_ACTIONS = {
	SET: 'MODULES_SET',
	SET_HOUSE: 'MODULES_SET_HOUSE'
};

export const KFZ_ACTIONS = {
	SET: 'KFZ_SET',
	REMOVE: 'KFZ_REMOVE',
	SET_MODELS: 'KFZ_SET_MODELS',
	REMOVE_MODEL: 'KFZ_REMOVE_MODEL'
};

export const SERVICES_KFZ_ACTIONS = {
	SET_KFZ: 'SET_KFZ_FOR_SERVICES',
	SET_SERVICE: 'SET_SERVICE_FOR_KFZ',
	UPDATE_KFZ_OF_SERVICE: 'SET_KFZ_DATA_IN_SERVICE',
	REMOVE_KFZ_OF_SERVICE: 'REMOVE_KFZ_DATA_IN_SERVICE',
	SET_MODELS: 'SET_KFZ_MODELS_FOR_SERVICES',
	REMOVE_MODELS: 'REMOVE_KFZ_MODELS_FROM_SERVICES'
};

export const SUPPORT_ACTIONS = {
	SET: 'SUPPORT_SET'
};


// WEBPACK FOOTER //
// ./src/actions/types.js